import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import "./Projects.scss";
import { ProjectList, ProjectStageSelection } from "projects/components";
import { useHasPermissions } from "auth/hooks";
import { useBoundStore } from "store";
import { buildOrganizationSectionPath } from "shared/utils/paths";

export const Projects = () => {
  const navigate = useNavigate();
  const { hasPermissions } = useHasPermissions();
  const { currentOrganization } = useBoundStore();

  return (
    <>
      <ProjectStageSelection
        extra={
          hasPermissions(["create:projects"]) ? (
            <Button
              type='primary'
              icon={<PlusOutlined />}
              onClick={() =>
                navigate(
                  buildOrganizationSectionPath(currentOrganization, "projects/new")
                )
              }
            >
              Add New Project
            </Button>
          ) : undefined
        }
      />
      <Row className='projects-project-list-container'>
        <Col span={24}>
          <ProjectList />
        </Col>
      </Row>
    </>
  );
};
